<template>
<div>
    <!-- modal -->
    <law-dailywork-description-selection-form @lawDailyworkDescriptionEmitValue="lawDailyworkDescriptionEmitValueFunction" ref="lawDailyworkDescriptionSelectionFormModal"></law-dailywork-description-selection-form>
    <b-modal id="dailyworkFormModal" ref="dailyworkFormModal" centered size="xl" no-close-on-backdrop :title="'Dailywork - '+recordNo +'-'+shortName" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <!-- STOCK-2940 1. Satir: Hizmet / Masraf, Kod, Aktivite Kodu, Time Keeper -->
            <b-row>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="dailywork-service-or-expense-input">{{ $t('dailywork.service_or_expense') }}</label>
                        <b-form-group>
                            <b-form-select :disabled="id > 0" id="dailywork-service-or-expense-input" size="sm" v-model="lawServiceTypeSelect" value-field="id" text-field="name" :options="lawServiceTypeOption" @change="serviceTypeChange()" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="dailywork-task-expense-input">{{ $t('dailywork.code') }}</label>
                        <b-form-group>
                            <validation-provider :name=" $t('dailywork.code')" :rules="{ excluded:0}" v-slot="{ errors }">
                                <b-form-select :disabled="id > 0" :state="errors.length > 0 ? false:null" id="dailywork-task-expense-input" size="sm" v-model="lawServiceSelect" value-field="id" text-field="name" :options="lawServiceOption" @change="serviceChange()" />

                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>

                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col v-if="lawServiceTypeSelect == 3" class="col-lg-3">
                    <b-form>
                        <label for="dailywork-activity-input">{{ $t('dailywork.activity_code') }}</label>
                        <b-form-group>
                            <b-form-select id="dailywork-activity-input" size="sm" v-model="lawActivitySelect" value-field="id" text-field="name" :options="lawActivityOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="dailywork-time-keeper-input">{{ $t('dailywork.employee') }}</label>
                        <b-form-group>
                            <b-form-select id="dailywork-time-keeper-input" size="sm" v-model="employeeSelect" @change="detectLawCostingType" value-field="id" text-field="name" :options="employeeOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <!-- STOCK-2940 2. Satir: Fatura Ajani, Ajan, Sahip, Odeme Durumu -->
            <b-row>
                <b-col class="col-lg-3">
                    <b-form>
                        <b-form-group :label="$t('dailywork.invoice_agent_name')" label-for="dailywork-not-accounting-invoice-agent-input">
                            <v-select size="sm" id="dailywork-not-accounting-invoice-agent-input" v-model="dailyworkInvoiceAgentSelect" :options="dailyworkInvoiceAgentOption" @input="setClientId" label="clientName" @search="onInvoiceClientAccountingSearch">
                            </v-select>
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="dailywork-agent-name-input">{{ $t('dailywork.agent_name') }}</label>
                        <b-form-group>
                            <b-form-input disabled size="sm" id="dailywork-agent-name-input" v-model="agentName" maxlength="300" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="dailywork-client-name-input">{{ $t('dailywork.client_name') }}</label>
                        <b-form-group>
                            <b-form-input disabled size="sm" id="dailywork-client-name-input" v-model="clientName" maxlength="300" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="dailywork-billing-status-input">{{ $t('dailywork.billing_status') }}</label>
                        <b-form-group>
                            <b-form-select id="dailywork-billing-status-input" size="sm" v-model="lawBillingStatusSelect" value-field="id" text-field="name" :options="lawBillingStatusOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col v-if="lawServiceTypeSelect == 2" class="col-lg">
                    <b-form>
                        <label for="dailywork-document-no-input">{{ $t('dailywork.document_no') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="dailywork-document-no-input" v-model="documentNo" maxlength="300" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col v-if="lawServiceTypeSelect == 2" class="col-lg">
                    <validation-provider #default="{ errors }" rules="required" :name="$t('others.date_is_empty')">
                        <b-form>
                            <label for="dailywork-document-date-input">{{ $t('dailywork.document_date') }}</label>
                            <b-form-group>
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('dailywork.document_date')" size="sm" v-model="documentDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </b-form>
                    </validation-provider>
                </b-col>
                <b-col v-if="lawServiceTypeSelect == 2" class="col-lg">
                    <b-form>
                        <label for="dailywork-vendor-input">{{ $t('dailywork.vendor') }}</label>
                        <b-form-group>
                            <b-form-select id="dailywork-vendor-input" size="sm" v-model="vendorSelect" value-field="code" text-field="name" :options="vendorOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col v-if="lawServiceTypeSelect == 1" class="col-lg-3">
                    <b-form>
                        <label for="dailywork-related-input">{{ $t('dailywork.related') }}</label>
                        <b-form-group>
                            <b-form-select id="dailywork-related-input" size="sm" v-model="relatedSelect" value-field="id" text-field="name" :options="relatedOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <b-row>
                            <b-col class="col-lg-6">
                                <label for="dailywork-description-input">{{ $t('dailywork.description') }}</label>
                            </b-col>
                            <b-col style="text-align:right" class="col-lg-6">
                                <b-button variant="primary" :title=" $t('lawDailyworkDescription.info')" class="mb-05" size="sm" @click="getDescriptionInfo(0)">
                                    <feather-icon icon="GitPullRequestIcon" />
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('dailywork.description')" rules="required">
                                <b-form-textarea :state="errors.length > 0 ? false:null" id="dailywork-description-input" :placeholder=" $t('dailywork.description')" v-model="description" rows="3" max-rows="20" maxlength="1000" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="dailywork-accounting-description-input">{{ $t('dailywork.accounting_description') }}</label>
                        <b-form-group>
                            <b-form-textarea id="dailywork-accounting-description-input" :placeholder=" $t('dailywork.accounting_description')" v-model="accountingDescription" rows="3" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-2 mt-1">
                    <label for="dailywork-invoice-accounting-const-type-input">{{ $t('dailywork.costing_type') }}</label>
                    <b-form-group>
                        <b-form-select :disabled="id > 0 || isDisable" size="sm" v-model="lawCostingTypeSelect" value-field="id" text-field="name" @change="detectLawCostingType" :options="lawCostingTypeOption" />
                    </b-form-group>
                </b-col>
                <b-col :hidden="lawCostingTypeSelect != 2"></b-col>
                <b-col :hidden="lawCostingTypeSelect == 2" class="col-lg-2 mt-1">
                    <label v-if="lawCostingTypeSelect == 3" for="dailywork-not-accounting-count-input">{{ $t('dailywork.hour') }}</label>
                    <label v-else for="dailywork-not-accounting-count-input">{{ $t('dailywork.count') }}</label>
                    <b-form-group>
                        <cleave id="dailywork-not-accounting-count-input" v-model="count" :onChange="priceCalculation()" class="cleaveStyle form-control" :options="cleaveOptionsForCount"></cleave>
                    </b-form-group>
                </b-col>
                <b-col class="col-lg-2 mt-1">
                    <label v-if="lawCostingTypeSelect == 2" for="dailywork-unit-price-input">{{ $t('dailywork.price') }}</label>
                    <label v-else for="dailywork-unit-price-input">{{ $t('dailywork.unit_price') }}</label>
                    <b-form-group>
                        <cleave id="dailywork-unit-price-input" v-model="unitPrice" :onChange="priceCalculation()" class="cleaveStyle form-control" :options="cleaveOptionsForPrice"></cleave>
                    </b-form-group>
                </b-col>
                <b-col class="col-lg-2 mt-1">
                    <label for="dailywork-not-accounting-currency-input">{{ $t('dailywork.currency_name') }}</label>
                    <b-form-group>
                        <b-form-select size="sm" v-model="currencySelect" value-field="id" text-field="code" :options="currencyOption" />
                    </b-form-group>
                </b-col>
                <b-col class="col-lg-2 mt-1">
                    <label for="dailywork-not-accounting-amount-input">{{ $t('dailywork.amount') }}</label>
                    <b-form-group>
                        <cleave id="dailywork-not-accounting-amount-input" disabled v-model="price" class="cleaveStyle form-control" :options="cleaveOptionsForPrice"></cleave>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="lawServiceTypeSelect == 3">
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2">
                    <label for="dailywork-not-accounting-discount-rate-input">{{ $t('dailywork.discount_rate') }}</label>
                    <b-form-group>
                        <cleave id="dailywork-not-accounting-discount-rate-input" v-model="discountRate" :onChange="priceCalculation()" class="cleaveStyle form-control" :options="cleaveOptions"></cleave>
                    </b-form-group>
                </b-col>
                <b-col class="col-lg-2">
                    <label for="dailywork-not-accounting-discount-input">{{ $t('dailywork.discount') }}</label>
                    <b-form-group>
                        <cleave id="dailywork-not-accounting-discount-input" disabled v-model="discount" class="cleaveStyle form-control" :options="cleaveOptions"></cleave>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="lawServiceTypeSelect == 3">
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2">
                    <label for="dailywork-not-accounting-vat-rate-input">{{$t('dailywork.vat_rate')}}</label>
                    <b-form-group>
                        <cleave disabled id="dailywork-not-accounting-vat-rate-input" v-model="vatRate" :onChange="priceCalculation()" class="cleaveStyle form-control" :options="cleaveOptions"></cleave>
                    </b-form-group>
                </b-col>
                <b-col class="col-lg-2">
                    <label for="dailywork-not-accounting-vat-input">{{ $t('dailywork.vat') }}</label>
                    <b-form-group>
                        <cleave id="dailywork-not-accounting-vat-input" disabled v-model="vat" class="cleaveStyle form-control" :options="cleaveOptionsForPrice"></cleave>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2"></b-col>
                <b-col class="col-lg-2">
                    <label for="dailywork-not-accounting-total-input">{{ $t('dailywork.total') }}</label>
                    <b-form-group>
                        <cleave disabled id="dailywork-not-accounting-total-input" v-model="total" class="cleaveStyle form-control" :options="cleaveOptionsForPrice"></cleave>
                    </b-form-group>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getDailyworkList: {
            type: Function
        },
        getDailyworkReportList: {
            type: Function
        },
    },
    computed: {
        //STOCK-2928 Ücret Türü = Saat ise saat alanında küsürat sadece 1 hane girilebilir
        cleaveOptionsForCount() {
            return {
                ...this.cleaveOptions,
                numeralDecimalScale: this.lawCostingTypeSelect == 3 ? 1 : 2
            }
        }
    },
    watch: {
        //STOCK-2166
        // lawServiceTypeSelect(val) {
        //     if (val == 2) {
        //         this.currencySelect = 4
        //     }
        // }
    },
    data() {
        return {
            id: 0,
            recordId: 0,
            lawServiceSelect: 0,
            lawServiceOption: [],
            lawServiceList: [],
            lawServiceTypeSelect: 0,
            lawServiceTypeOption: [],
            lawActivitySelect: 0,
            lawActivityOption: [],
            employeeSelect: 0,
            employeeOption: [],
            dailyworkInvoiceAgentSelect: 0,
            dailyworkInvoiceAgentOption: [],
            matterName: '',
            clientName: '',
            agentName: '',
            invoiceAgentName: '',
            lawBillingStatusSelect: 0,
            lawBillingStatusOption: [],
            relatedSelect: 0,
            relatedOption: [],
            vendorSelect: 0,
            vendorOption: [],
            documentNo: '',
            documentDate: null,
            description: null,
            accountingDescription: '',
            lawCostingTypeSelect: 0,
            lawCostingTypeOption: [],
            //baseLawCostingTypeOption: [],
            count: '',
            unitPrice: '',
            currencySelect: 0,
            currencyOption: [],
            withholdingTax: '',
            price: '',
            matterName: '',
            vat: 0,
            vatRate: 0,
            discount: 0,
            discountRate: 0,
            total: 0,
            isDisable: true,
            cleaveOptions: {
                prefix: '',
                numeral: true,
                numeralPositiveOnly: true,
                noImmediatePrefix: true,
                rawValueTrimPrefix: true,
                numeralIntegerScale: 9,
                numeralDecimalScale: 2
            },
            cleaveOptionsForPrice: {
                prefix: '',
                numeral: true,
                numeralPositiveOnly: false,
                noImmediatePrefix: true,
                rawValueTrimPrefix: true,
                numeralIntegerScale: 9,
                numeralDecimalScale: 2
            },
            recordNo: '',
            shortName: '',
        }
    },
    methods: {
        async getDescriptionInfo(id) {
            this.$refs.lawDailyworkDescriptionSelectionFormModal.showInfo()
        },
        lawDailyworkDescriptionEmitValueFunction(val) {
            this.description = val.name
            // This Code Isnt Make any sense if CurrencyId values Change this code will not work !!! 13.11.2024 Nevzat.
            if (this.currencySelect == 1) //CHF
            {
                this.unitPrice = val.chf
            } else if (this.currencySelect == 2) //EUR
            {
                this.unitPrice = val.eur
            } else if (this.currencySelect == 3) //GBP
            {
                this.unitPrice = val.gbp
            } else if (this.currencySelect == 5) // USD
            {
                this.unitPrice = val.usd
            }
        },
        detectLawCostingType() {
            if (this.lawCostingTypeSelect == 2) {
                this.count = 1
            } else if (this.lawCostingTypeSelect == 3) {
                //STOCK-2928 Saat türüne geçildiğinde varsa 2 haneli küsürat 1 haneye indirilir
                this.trimCountDecimal()
                if (this.employeeSelect > 0 && this.currencySelect > 0) {
                    this.getLawEmployeePrice()
                }
            }
        },
        //STOCK-2928
        trimCountDecimal() {
            const value = parseFloat(this.count)
            if (!isNaN(value)) {
                this.count = (Math.floor(value * 10) / 10).toString()
            }
        },
        setClientId(event) {
            if (event != null) {
                this.clientId = event.clientId
            } else {
                this.clientId = null;
            }
        },
        async serviceChange() {
            if (this.lawServiceSelect > 0) {
                var serviceInfo = this.lawServiceList.filter(p => p.id == this.lawServiceSelect)

                this.count = 1
                if (this.lawServiceTypeSelect == 2) {
                    this.vatRate = 0
                } else {
                    this.vatRate = 20
                }

                this.lawCostingTypeSelect = serviceInfo[0].lawCostingTypeId
                this.description = serviceInfo[0].description
                this.isDisable = serviceInfo[0].isDisable
                this.detectLawCostingType()
                this.priceCalculation()
            }
        },
        priceCalculation() {
            this.price = (parseFloat(this.count * parseFloat(this.unitPrice).toFixed(2)) + parseFloat(this.withholdingTax)).toFixed(2)
            this.discount = (this.price * this.discountRate / 100).toFixed(2)
            this.vat = ((this.price - this.discount) * this.vatRate / 100).toFixed(2)
            this.total = (parseFloat(this.price) - parseFloat(this.discount) + parseFloat(this.vat)).toFixed(2)
        },
        onInvoiceClientAccountingSearch(invoiceClientAccountingSearch, loading) {
            if (invoiceClientAccountingSearch.length) {
                loading(true);
                this.invoiceClientAccountingSearch(loading, invoiceClientAccountingSearch, this);
            }
        },
        invoiceClientAccountingSearch(loading, invoiceClientAccountingSearch, vm) {
            if (invoiceClientAccountingSearch.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    clientName: invoiceClientAccountingSearch
                }
                const controller = {
                    name: 'LawClient',
                    actionName: 'GetClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.dailyworkInvoiceAgentOption = response.data.clientList
                    loading(false)
                })
            }
        },
        serviceTypeChange() {
            this.lawServiceOption = this.lawServiceList.filter(p => p.lawServiceTypeId == this.lawServiceTypeSelect)
            //STOCK-2940 Aktivite Kodu yalnizca Hizmet seciliyken gorunur, Masrafta secim temizlenir.
            if (this.lawServiceTypeSelect != 3) {
                this.lawActivitySelect = 0
            }
            this.lawServiceOption.splice(0, 0, this.$nullSelected())

            if (this.id == 0)
                this.lawServiceSelect = 0;
        },
        showInfo(id, recordId, recordNo, shortName) {
            this.$refs['dailyworkFormModal'].show()

            this.id = id
            this.recordId = recordId
            this.recordNo = recordNo
            this.shortName = shortName
            const data = {
                id: this.id,
                recordId: this.recordId
            }
            const controller = {
                name: 'LawDailywork'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {

                    if (response.data.lawDailywork.employeeId > 0) {
                        this.employeeSelect = response.data.lawDailywork.employeeId;
                    } else {
                        this.employeeSelect = localStorage.getItem('EmployeeId');
                    }

                    this.lawServiceSelect = response.data.lawDailywork.lawServiceId
                    this.lawServiceList = response.data.lawServiceList
                    this.lawServiceTypeSelect = response.data.lawDailywork.lawServiceTypeId
                    this.lawServiceTypeOption = response.data.lawServiceTypeList
                    this.lawActivitySelect = response.data.lawDailywork.lawActivityId
                    this.lawActivityOption = response.data.lawActivityList
                    this.employeeOption = response.data.employeeList
                    this.matterName = response.data.lawDailywork.matterName
                    this.clientName = response.data.lawDailywork.ownerClient
                    this.agentName = response.data.lawDailywork.agent
                    this.invoiceAgentName = response.data.lawDailywork.invoiceClient
                    this.lawBillingStatusSelect = response.data.lawDailywork.lawBillingStatusId
                    this.lawBillingStatusOption = response.data.lawBillingStatusList
                    this.relatedSelect = response.data.lawDailywork.relatedId
                    this.relatedOption = response.data.relatedList
                    this.vendorSelect = response.data.lawDailywork.vendorCode
                    this.vendorOption = response.data.vendorList
                    this.documentNo = response.data.lawDailywork.documentNo
                    this.documentDate = response.data.lawDailywork.documentDate
                    this.description = response.data.lawDailywork.description
                    this.accountingDescription = response.data.lawDailywork.accountingDescription
                    this.lawCostingTypeSelect = response.data.lawDailywork.lawCostingTypeId
                    this.lawCostingTypeOption = response.data.lawCostingTypeList
                    this.lawCostingTypeOption = response.data.lawCostingTypeList
                    this.count = response.data.lawDailywork.count
                    this.unitPrice = response.data.lawDailywork.unitPrice
                    this.currencySelect = response.data.lawDailywork.currencyId
                    this.currencyOption = response.data.currencyList
                    this.withholdingTax = response.data.lawDailywork.withholdingTax
                    this.price = response.data.lawDailywork.price
                    this.matterName = response.data.lawDailywork.matterName
                    this.vatRate = response.data.lawDailywork.vatRate
                    this.discountRate = response.data.lawDailywork.discount
                    this.lawActivityOption.splice(0, 0, this.$nullSelected())
                    this.lawBillingStatusOption.splice(0, 0, this.$nullSelected())
                    this.employeeOption.splice(0, 0, this.$nullSelected())
                    this.vendorOption.splice(0, 0, this.$nullSelected())
                    if (this.id == 0) {
                        this.lawServiceTypeSelect = 3
                        this.lawBillingStatusSelect = 1
                    } else {
                        this.lawBillingStatusSelect = response.data.lawDailywork.lawBillingStatusId
                        this.lawServiceTypeSelect = response.data.lawDailywork.lawServiceTypeId
                    }

                    this.serviceTypeChange()
                    this.priceCalculation()

                    if (response.data.lawDailywork.invoiceClientAccountingId > 0) {
                        const clientAccountingData = {
                            clientAccountingId: response.data.lawDailywork.invoiceClientAccountingId
                        }
                        const clientAccountingController = {
                            name: 'ClientAccounting',
                            actionName: 'GetClientAccountingByClientName'
                        }
                        const clientAccountingPayload = {
                            data: clientAccountingData,
                            controller: clientAccountingController
                        }
                        this.$store.dispatch('moduleAuth/customService', clientAccountingPayload).then((clientAccountingResponse) => {
                            this.dailyworkInvoiceAgentOption = clientAccountingResponse.data.clientList
                            this.dailyworkInvoiceAgentSelect = clientAccountingResponse.data.clientList[0]
                        })

                    } else {
                        this.dailyworkInvoiceAgentOption = []
                        this.dailyworkInvoiceAgentSelect = 0;
                    }

                } else {
                    this.$bvModal.hide('dailyworkFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    const data = {
                        id: this.id,
                        recordId: this.recordId,
                        lawServiceId: this.lawServiceSelect,
                        lawServiceTypeId: this.lawServiceTypeSelect,
                        lawActivityId: this.lawActivitySelect,
                        employeeId: this.employeeSelect,
                        matterName: this.matterName,
                        invoiceClientAccountingId: this.dailyworkInvoiceAgentSelect.clientAccountingId,
                        lawBillingStatusId: this.lawBillingStatusSelect,
                        relatedId: this.relatedSelect,
                        vendorCode: this.vendorSelect,
                        documentNo: this.documentNo,
                        documentDate: this.documentDate,
                        description: this.description,
                        accountingDescription: this.accountingDescription,
                        lawCostingTypeId: this.lawCostingTypeSelect,
                        count: this.count,
                        unitPrice: this.unitPrice,
                        currencyId: this.currencySelect,
                        withholdingTax: this.withholdingTax,
                        price: this.total,
                        vatRate: this.vatRate,
                        discount: this.discountRate,
                        recordEmployeeId: localStorage.getItem('EmployeeId'),
                    }
                    const controller = {
                        name: 'LawDailywork'
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('dailyworkFormModal')
                            if (this.getDailyworkList != null) {
                                this.getDailyworkList()
                            }
                            if (this.getDailyworkReportList != null) {
                                this.getDailyworkReportList()
                            }

                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
        getLawEmployeePrice() {
            const data = {
                employeeId: this.employeeSelect,
                currencyId: this.currencySelect
            }
            const controller = {
                name: 'EmployeePrice',
                actionName: "GetEmployeePriceByCurrencyIdAndEmployeeId"
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true && response.data.employeePrice != null) {
                    this.unitPrice = parseFloat(response.data.employeePrice.price).toFixed(2)
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.cleaveStyle {
    max-height: 3em !important;
    height: 2.2em !important;
}
</style>
